export default class RCSettings {
    settings: RCSetting[] = []
}

export class RCSetting {
    type: string = ""
    name: string = ""
    value: any
    index: number = -1
    children: RCSetting[] = []
    useValue: boolean = true
}